
import TableList from "@components/templates/tablelist";
import { HttpGetWarehouse, HttpFailureWarehouse, HttpSoloFailureWarehouse, HttpSoloActiveWarehouse, HttpAllActiveWarehouse} from "@/service/managechannel/managechannel";
import { mapState,mapGetters } from "vuex";
import compbatchImgUpload from "@components/templates/selectupload";
export default {
    mixins: [TableList],
    components: {
        compbatchImgUpload
    },
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            erpSkusList:[],
        };
    },
    methods: {
        ajaxRequest: HttpGetWarehouse,
        interceptRequest(params){
            params.country = params.search.country
            delete params.search.country
            // console.log(params)
            return params
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(type!='addnewpage'){
                if(batch){
                    params=(params||this.checkedData.join(','))+'';
                    if(!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: '请选择至少一条数据' }));
                }
            }
            switch (type) {
                case "addnewpage":
                    this.$router.push({
                        name: 'managewareUpdate',
                        params: { type: "addnewpage" },
                        query: { id: params },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'managewareUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    var url=this.$router.resolve({
                        name: "managewareUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "failure":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{ids:params},
                        title: this.$t('erp.managewarehouse.batch_loss_effect', { defaultValue: "批量失效" }),
                        ajaxRequest:HttpFailureWarehouse
                    }
                    break;
                case "solofailure":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{id:params},
                        title: this.$t('fbb.accountmanage.operate_loss_effect', { defaultValue: "失效操作" }),
                        ajaxRequest:HttpSoloFailureWarehouse
                    }
                    break;
                case "active":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{id:params},
                        title: this.$t('erp.managewarehouse.active_effect_operation', { defaultValue: "生效操作" }),
                        ajaxRequest:HttpSoloActiveWarehouse
                    }
                    break;
                case "allactive":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params},
                        title: this.$t('erp.managewarehouse.batch_active_effect', { defaultValue: "批量生效" }),
                        ajaxRequest:HttpAllActiveWarehouse
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        name: "excelFile",
                        component: "compbatchImgUpload",
                        showdownload:2,
                        actionurl:process.env.VUE_APP_APIURL_FBB + "/api/v2/OrgWarehouseCarrierService/batchImport",
                        params:{isUpdate:0},
                        formdata: [
                            {
                                span:24,
                                label: this.$t('erp.managewarehouse.dataisupdate', { defaultValue: '已有数据是否更新' }),
                                key: 'isUpdate',
                                tag: 'vRadio',
                                props: {
                                    strict: false,
                                },
                                options: [{
                                    trueValue: 1,
                                    label: this.$t("erp.global.yes", { defaultValue: "是" })
                                }, {
                                    trueValue: 0,
                                    label: this.$t("erp.global.no", { defaultValue: "否" })
                                }]
                            },
                        ],
                        downrul:process.env.VUE_APP_APIURL_FBB + "/api/v2/OrgWarehouseCarrierService/orgWarehouseCarrierTemplate"
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/OrgWarehouseCarrierService/export',{ids:params},'download');
                    break;
                
            }
        },
        // downloadExcel(){
        //     this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/OrgWarehouseCarrierService/orgWarehouseCarrierTemplate", {}, 'download') 
        // },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, status } = row
            return [{
                label: this.$t('global.common.operation_see', { defaultValue: '查看' }),
                show:true,
                params:id,
                operate:'query'
            },{
                label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                show:status!=1,
                params:id,
                operate:'edit'
            },{
                label: this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }),
                show:status!=1,
                params:id,
                operate:'solofailure'
            },
            {
                label: this.$t('erp.managewarehouse.active_effect', { defaultValue: '生效' }),
                show:status==1,
                params:id,
                operate:'active'
            }]
        },
        dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
    },
    computed: {
        ...mapState('boss', ['countries','sysdeliveries','orgwarehouses','accountTypes']),
        ...mapGetters('diction',['getNewAccountList','getNewWarehouseIdList']),
        // table中单据状态的按钮展示
        orderStatus(){
            return [
                {
                    value: '0',
                    label: this.$t('global.common.effective', { defaultValue: '有效' }),
                    theme:'info',
                },
                {
                    value: '1',
                    label: this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }),
                    theme:'error',
                }, 
            ];
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: "添加" }),
                    operate: "addnewpage",
                    theme: "primary",
                    batch:true,
                },
                {
                    name: this.$t('erp.managewarehouse.batch_active_effect', { defaultValue: "批量生效" }),
                    operate: "allactive",
                    more: true,
                    batch:true,
                },
                {
                    name: this.$t('fbb.accountmanage.muti_loss_effect', { defaultValue: "批量失效" }),
                    operate: "failure",
                    more: true,
                    batch:true,
                },
                {
                    name: this.$t('fbb.alloment.muti_import', { defaultValue: "批量导入" }),
                    operate: "import",
                    more: true,
                },
                {
                    name: this.$t('fbb.alloment.muti_export', { defaultValue: "批量导出" }),
                    operate: "export",
                    more: true,
                    batch:true,
                }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            const dropStyle="width:auto;min-width:200px;";
            return  [
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: "物流产品服务" }),
                    tag: 'Input',
                    key: 'CN_code',
                    show:true,
                    // options:this.sysdeliveries.map(function(item){
                    //     const {carrierServiceCode}=item;
                    //     return {
                    //         value: carrierServiceCode,
                    //         label: carrierServiceCode
                    //     }
                    // }),
                    // props:{
                    //     dropStyle,
                    //     filterable:true,
                    // },
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseId',
                    show:true,
                    options:this.getNewWarehouseIdList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.managewarehouse.warehouse_country', { defaultValue: "仓库所在国家" }),
                    tag: 'vSelect',
                    key: 'country',
                    options:this.countries.map(function(item){
                        // console.log(item)
                        const {code,nameEn} = item;
                        return {
                            value: code ? code : nameEn,
                            label: code + ' (' + nameEn + ')'
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    tag: 'vSelect',
                    key: 'EQ_status',
                    options: [
                        {
                            value: '0',
                            label: this.$t('global.common.effective', { defaultValue: '有效' })
                        },
                        {
                            value: '1',
                            label: this.$t('global.common.failure', { defaultValue: '失效' })
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.managewarehouse.shop_type', { defaultValue: "店铺类型" }),
                    tag: 'vSelect',
                    key: 'EQ_channelType',
                    options:this.accountTypes.map(function(item){
						// console.log(item)
                        return {
                            value: item.name,
                            label: item.name
                        }
					}),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('erp.managewarehouse.shop_name', { defaultValue: "店铺名称" }),
                    tag: 'vSelect',
                    key: 'EQ_channelAccount',
                    options:this.getNewAccountList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                // {
                //     label: this.$t('erp.managewarehouse.warehouse_shipping_method_code', { defaultValue: "仓库Shipping Method Code" }),
                //     tag: 'vInput',
                //     key: 'EQ_carrierServiceApiCode',
                //     formItem:{
                //         labelWidth:164,
                //     }
                // },
                
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t('global.common.actions', { defaultValue: '操作' }),
                width: 70,
                render:this.getOperateNodes
            }, 
            {
                title: this.$t('fbb.alloment.carrier_server', { defaultValue: "物流产品服务" }),
                // key: 'lineId',
                render:(h,{row})=>{
                    return <div>{row.code} ({row.carrierServiceName})</div>
                }
            },
            
            
            {
                title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                // key: 'warehouseCode',
                render:(h,{row})=>{
                    return <div>{row.warehouseCode}({row.warehouseTitle})</div>
                }
            },
            {
                title: this.$t('erp.managewarehouse.shop_shop_name', { defaultValue: '店铺/店铺名称' }),
                render:(h,{row})=>{
                    return <div>{row.channelType}<span v-show={row.channelType&&row.channelAccount}>/</span>{row.channelAccount}</div>
                }
            },
            {
                title: this.$t('erp.managewarehouse.print_order_account', { defaultValue: '打单账号' }),
                maxWidth:100,
                render:(h,{row})=>{
                    return <div>{row.carrierAccount}</div>
                }
            },
            // {
            //     title: this.$t('erp.managewarehouse.warehouse_shipping_type', { defaultValue: '仓库发运方式' }),
            //     key: 'carrierServiceApiCode',
            // },
            {
                title: this.$t('fbb.headlogistics.order_status', { defaultValue: '单据状态' }),
                key: 'status',
                sortable: true,
                maxWidth:80,
                render:(h, { row })=>{
                    const status=row.status;
                    const {theme,label}=this.orderStatus.find(function(item){
                        return item.value==status
                    })||{};
                    return <vButton ghost theme={theme} size="small" class="cursor-default width-60">{label}</vButton>
                }
            },
            {
                title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                key: 'updatedAt',
                sortable: true
            }
        ];
        },
        
    },

};
